import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";

import Navbar from "./components/site/Navbar";
import Footer from "./components/site/Footer";
import VisitTracker from "./components/site/VisitTracker";
import Home from "./pages/Home";
import Galerie from "./pages/Galerie";
import APropos from "./pages/APropos";
import Tarifs from "./pages/Tarifs";
import Contact from "./pages/Contact";
import Temoignages from "./pages/Temoignages";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import { AuthProvider } from "./context/AuthContext";

function Shell({ children }) {
    const location = useLocation();
    const isAdmin = location.pathname.startsWith("/admin");
    return (
        <div className="App grain min-h-screen flex flex-col">
            {!isAdmin && <Navbar />}
            <main className="flex-1">{children}</main>
            {!isAdmin && <Footer />}
        </div>
    );
}

function App() {
    return (
        <HelmetProvider>
            <AuthProvider>
                <BrowserRouter>
                    <VisitTracker />
                    <Shell>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/galerie" element={<Galerie />} />
                            <Route path="/a-propos" element={<APropos />} />
                            <Route path="/tarifs" element={<Tarifs />} />
                            <Route path="/temoignages" element={<Temoignages />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/admin/login" element={<AdminLogin />} />
                            <Route path="/admin" element={<AdminDashboard />} />
                        </Routes>
                    </Shell>
                    <Toaster
                        position="bottom-right"
                        theme="dark"
                        toastOptions={{
                            style: {
                                background: "#0f0f0f",
                                border: "1px solid rgba(255,255,255,0.1)",
                                color: "#f8f8f8",
                            },
                        }}
                    />
                </BrowserRouter>
            </AuthProvider>
        </HelmetProvider>
    );
}

export default App;
